<template>
    <div>
        <div v-if="!loading && project !== null">
            <div class="columns">
                <div class="column">
                    <div v-if="project.name" class="field__wrapper">
                        <p class="field_label">Название практики</p>
                        <p class="field_value">{{ project.name }}</p>
                    </div>

                    <div v-if="project.publishYear" class="field__wrapper">
                        <p class="field_label">Год реализации</p>
                        <p class="field_value">{{ project.publishYear }}</p>
                    </div>

                    <div v-if="project.annotation" class="field__wrapper">
                        <p class="field_label">Общее описание практики</p>
                        <div class="field_value" v-html="project.annotation"></div>
                    </div>
								</div>
						</div>
				</div>
        <div v-else>
            <Spin></Spin>
        </div>
		</div>
</template>

<script setup>
import {Spin} from "ant-design-vue";
import {ref} from "vue";
import axios from "axios";
import Json from "@/services/json";

let loading = ref(true);
let project = ref(null);

async function getData() {
  loading.value = true;
  const projects_response = await axios.get('/api/projects/' + window.film_id + '.json');
  projects_response.data = Json.replaceKeys(projects_response.data);
  project.value = projects_response.data;
  loading.value = false;
}
getData();
</script>

<style scoped>
.field__wrapper {
    margin-bottom: 20px;
}
.field_label {
    font-weight: bold;
}
</style>